import * as React from "react";
const SvgFiRrBellSchoolSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bell-school-slash_svg__a)">
      <path
        fill="#062147"
        d="M16.883 21.222a1 1 0 0 1-.413 1.353 13.5 13.5 0 0 1-3.954 1.377 2.95 2.95 0 0 1-2.43-.646 3.01 3.01 0 0 1-1.085-2.316v-1.041c-5.047-.503-9-4.772-9-9.95 0-1.141.19-2.263.567-3.332a1.001 1.001 0 0 1 1.886.666A8 8 0 0 0 2 10c0 4.41 3.59 8 8 8a8 8 0 0 0 2.666-.456 1.001 1.001 0 0 1 .668 1.885 10 10 0 0 1-2.334.517v1.045c0 .302.134.586.366.78.131.11.413.286.792.214a11.5 11.5 0 0 0 3.372-1.174 1 1 0 0 1 1.353.412zm6.824 1.07a.999.999 0 1 1-1.414 1.415l-22-22A.999.999 0 1 1 1.707.293l1.97 1.969A9.94 9.94 0 0 1 10 0a9.97 9.97 0 0 1 8.382 4.555.998.998 0 0 1-.837 1.545 1 1 0 0 1-.839-.455A7.98 7.98 0 0 0 10 1.999 7.96 7.96 0 0 0 5.096 3.68L9.49 8.074a1.99 1.99 0 0 1 1.925.51c.522.523.687 1.26.511 1.926l4.388 4.388q.208-.264.394-.547a1 1 0 1 1 1.674 1.093 10 10 0 0 1-.647.874l1.46 1.46c1.174-1.43 2.001-3.083 2.437-4.85-.204.044-.414.07-.63.07-1.655 0-3-1.346-3-3s1.345-3 3-3c1.653 0 3 1.346 3 3 0 3.379-1.208 6.616-3.389 9.198l3.095 3.095zM22 10a1.001 1.001 0 0 0-2 0 1.001 1.001 0 0 0 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bell-school-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBellSchoolSlash;
